// src/components/Header.jsx
import React, { useState } from "react";
import "./Header.css";
import logo from "../../Asstes/Images/logo.png";

import dropDownIcon from "../../Asstes/Images/drop-down.svg";
import forCompanies1 from "../../Asstes/Images/for-companies-menu-1.png";
import forCompanies2 from "../../Asstes/Images/for-companies-menu-2.png";
import forCompanies3 from "../../Asstes/Images/for-companies-menu-3.png";
import forCompanies4 from "../../Asstes/Images/for-companies-menu-4.png";
import forCompanies5 from "../../Asstes/Images/for-companies-menu-5.png";
import forCompanies6 from "../../Asstes/Images/for-companies-menu-6.png";

import forJobseekers1 from "../../Asstes/Images/for-jobseekers-menu-1.png";
import forJobseekers2 from "../../Asstes/Images/for-jobseekers-menu-2.png";
import forJobseekersBlog from "../../Asstes/Images/for-jobseekers-menu-blog.png";
import forJobseekers1Program from "../../Asstes/Images/for-jobseekers-menu-1-program.png";
import service1 from "../../Asstes/Images/service-menu-1.png";
import service2 from "../../Asstes/Images/service-menu-2.png";
import service3 from "../../Asstes/Images/service-menu-3.png";
import service4 from "../../Asstes/Images/service-menu-4.png";

const Header = () => {
  // Desktop state
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  // Mobile state
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState(null);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const toggleMobileSubmenu = (menu) => {
    setMobileSubmenuOpen(mobileSubmenuOpen === menu ? null : menu);
  };

  return (
    <>
      {/* ===== Desktop Header ===== */}
      <header className="header">
        <div className="logo">
          <a href="/">
            <img src={logo} alt="ProSapiens Logo" />
          </a>
        </div>
        <nav className="navbar">
          <ul className="nav">
            <li><a href="/about">About Us</a></li>

            <li className="dropdown" onMouseEnter={() => setActiveSubmenu('companies')} onMouseLeave={() => setActiveSubmenu(null)}>
              <a href="#" className="dropdown-toggle">For Companies <img src={dropDownIcon} alt="dropdown" /></a>
              <div className={`mega-menu ${activeSubmenu === 'companies' ? 'show' : ''}`}>
                <div className="menu-item"><img src={forCompanies1} alt="menu" /><span><a href="/hire-about-prosapiens">About ProSapiens</a></span></div>
                <div className="menu-item"><img src={forCompanies2} alt="menu" /><span><a href="/process">Process</a></span></div>
                <div className="menu-item"><img src={forCompanies3} alt="menu" /><span><a href="/blog-resources">Blog/Resources</a></span></div>
                <div className="menu-item"><img src={forCompanies4} alt="menu" /><span><a href="/company-reviews">Reviews</a></span></div>
                <div className="menu-item"><img src={forCompanies5} alt="menu" /><span><a href="/company-1-program">1% Program</a></span></div>
                <div className="menu-item"><img src={forCompanies6} alt="menu" /><span><a href="/company-remote-program">Remote Program</a></span></div>
              </div>
            </li>

            <li className="dropdown" onMouseEnter={() => setActiveSubmenu('jobseekers')} onMouseLeave={() => setActiveSubmenu(null)}>
              <a href="#" className="dropdown-toggle">For Jobseekers <img src={dropDownIcon} alt="dropdown" /></a>
              <div className={`mega-menu ${activeSubmenu === 'jobseekers' ? 'show' : ''}`}>
                <div className="menu-item"><img src={forJobseekers1} alt="menu" /><span><a href="/openings">Openings</a></span></div>
                <div className="menu-item"><img src={forJobseekers2} alt="menu" /><span><a href="/jobseekers-blog">Blog/Resources</a></span></div>
                <div className="menu-item"><img src={forJobseekersBlog} alt="menu" /><span><a href="/jobseekers-reviews">Reviews</a></span></div>
                <div className="menu-item"><img src={forJobseekers1Program} alt="menu" /><span><a href="/jobseekers-1-program">1% Program</a></span></div>
                <div className="menu-item"><img src={forJobseekers2} alt="menu" /><span><a href="/jobseekers-remote-program">Remote Program</a></span></div>
              </div>
            </li>

            <li className="dropdown" onMouseEnter={() => setActiveSubmenu('services')} onMouseLeave={() => setActiveSubmenu(null)}>
              <a href="#" className="dropdown-toggle">Services <img src={dropDownIcon} alt="dropdown" className="img-service" /></a>
              <div className={`mega-menu ${activeSubmenu === 'services' ? 'show' : ''}`}>
                <div className="menu-item"><img src={service1} alt="menu" /><span><a href="/recruitment">Recruitment</a></span></div>
                <div className="menu-item"><img src={service2} alt="menu" /><span><a href="/organizational-development">Organizational Development</a></span></div>
                <div className="menu-item"><img src={service3} alt="menu" /><span><a href="/learning-development">Learning & Development</a></span></div>
                <div className="menu-item"><img src={service4} alt="menu" /><span><a href="/hr-outsourcing">HR Outsourcing</a></span></div>
              </div>
            </li>

            <li><a href="/blog">Blogs</a></li>
          </ul>
        </nav>
      </header>
      {/* ===== Mobile Header (Below Desktop) ===== */}
      <header className="header-mobile">
        <div className="header-mobile-top">
          <a href="/" className="header-mobile-logo">
            <img src={logo} alt="Logo" />
          </a>
          <div className="header-mobile-burger" onClick={toggleMobileMenu}>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="header-mobile-menu">
            <a href="/about">About Us</a>

            <div className="header-mobile-submenu">
              <div className="submenu-toggle" onClick={() => toggleMobileSubmenu("companies")}>
                For Companies <img src={dropDownIcon} alt="dropdown" />
              </div>
              {mobileSubmenuOpen === "companies" && (
                <div className="submenu-content">
                  <a href="/hire-about-prosapiens">About ProSapiens</a>
                  <a href="/process">Process</a>
                  <a href="/blog-resources">Blog/Resources</a>
                  <a href="/company-reviews">Reviews</a>
                  <a href="/company-1-program">1% Program</a>
                  <a href="/company-remote-program">Remote Program</a>
                </div>
              )}
            </div>

            <div className="header-mobile-submenu">
              <div className="submenu-toggle" onClick={() => toggleMobileSubmenu("jobseekers")}>
                For Jobseekers <img src={dropDownIcon} alt="dropdown" />
              </div>
              {mobileSubmenuOpen === "jobseekers" && (
                <div className="submenu-content">
                  <a href="https://www.prosapiens.co.in/wp/job-openings/">Openings</a>
                  <a href="/jobseekers-blog">Blog/Resources</a>
                  <a href="/jobseekers-reviews">Reviews</a>
                  <a href="/jobseekers-1-program">1% Program</a>
                  <a href="/jobseekers-remote-program">Remote Program</a>
                </div>
              )}
            </div>

            <div className="header-mobile-submenu">
              <div className="submenu-toggle" onClick={() => toggleMobileSubmenu("services")}>
                Services <img src={dropDownIcon} alt="dropdown" />
              </div>
              {mobileSubmenuOpen === "services" && (
                <div className="submenu-content">
                  <a href="/recruitment">Recruitment</a>
                  <a href="/organizational-development">Organizational Development</a>
                  <a href="/learning-development">Learning & Development</a>
                  <a href="/hr-outsourcing">HR Outsourcing</a>
                </div>
              )}
            </div>

            <a href="/blog">Blogs</a>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
